import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly snackBar = inject(MatSnackBar);

  private readonly defaultDuration = 3000;
  private readonly errorDuration = 5000;

  success(message: string, action = 'Close', duration = this.defaultDuration) {
    this.show(message, action, NotificationType.SUCCESS, duration);
  }

  error(message: string, action = 'Close', duration = this.errorDuration) {
    this.show(message, action, NotificationType.ERROR, duration);
  }

  info(message: string, action = 'Close', duration = this.defaultDuration) {
    this.show(message, action, NotificationType.INFO, duration);
  }

  warning(message: string, action = 'Close', duration = this.defaultDuration) {
    this.show(message, action, NotificationType.WARNING, duration);
  }

  private show(
    message: string,
    action: string,
    type: NotificationType,
    duration: number
  ) {
    this.snackBar.open(message, action, {
      panelClass: `snackbar-${type}`,
      duration,
    });
  }
}
